module.exports = __webpack_public_path__ + "img/qian_qianProgress.aa2d189b.svg";